var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlackLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15789 21.4737C7.15789 23.4503 5.55559 25.0526 3.57895 25.0526C1.60231 25.0526 0 23.4503 0 21.4737C0 19.4971 1.60231 17.8947 3.57895 17.8947H7.15789V21.4737Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94739 21.4737C8.94739 19.4971 10.5497 17.8947 12.5263 17.8947C14.503 17.8947 16.1053 19.4971 16.1053 21.4737V30.4211C16.1053 32.3977 14.503 34 12.5263 34C10.5497 34 8.94739 32.3977 8.94739 30.4211V21.4737Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5263 7.15789C10.5497 7.15789 8.94739 5.55559 8.94739 3.57895C8.94739 1.60231 10.5497 0 12.5263 0C14.503 0 16.1053 1.60231 16.1053 3.57895V7.15789H12.5263Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5263 8.94737C14.503 8.94737 16.1053 10.5497 16.1053 12.5263C16.1053 14.503 14.503 16.1053 12.5263 16.1053H3.57895C1.60231 16.1053 0 14.503 0 12.5263C0 10.5497 1.60231 8.94737 3.57895 8.94737H12.5263Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8421 12.5263C26.8421 10.5497 28.4444 8.94737 30.421 8.94737C32.3977 8.94737 34 10.5497 34 12.5263C34 14.503 32.3977 16.1053 30.421 16.1053H26.8421V12.5263Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0527 12.5263C25.0527 14.503 23.4504 16.1053 21.4737 16.1053C19.4971 16.1053 17.8948 14.503 17.8948 12.5263V3.57895C17.8948 1.60231 19.4971 0 21.4737 0C23.4504 0 25.0527 1.60231 25.0527 3.57895V12.5263Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4737 26.8421C23.4504 26.8421 25.0527 28.4444 25.0527 30.421C25.0527 32.3977 23.4504 34 21.4737 34C19.4971 34 17.8948 32.3977 17.8948 30.421V26.8421H21.4737Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4737 25.0526C19.4971 25.0526 17.8948 23.4503 17.8948 21.4737C17.8948 19.4971 19.4971 17.8947 21.4737 17.8947H30.4211C32.3977 17.8947 34 19.4971 34 21.4737C34 23.4503 32.3977 25.0526 30.4211 25.0526H21.4737Z",
    fill: "#ECB22E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.35198e2278002a4bf493048ffd41253b.svg";
export { ForwardRef as ReactComponent };